import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';

const openedMixin = (theme) => ({
  overflowX: 'hidden',
  padding: 0,
  borderRadius: 0,
  width: theme.layout.sidebar.maxWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
});

const closedMixin = (theme) => ({
  overflowX: 'hidden',
  padding: 0,
  borderRadius: 0,
  width: theme.layout.sidebar.minWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
});

const SidebarDrawer = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: theme.layout.sidebar.width,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

SidebarDrawer.displayName = 'SidebarDrawer';
export default SidebarDrawer;
